window.OSP_MANUAL_DATA = {
  "manual": {
    "title": "Venix manual",
    "hero_title": "Venix",
    "product_family": "Venix",
    "primary_app": "Tuya Smart",
    "manual_version": "V26.1",
    "lead": "Install Venix, connect Tuya Smart and manage access with illustrated source instructions.",
    "app_links": {},
    "checklist": [
      "Check that the model on your device matches this manual.",
      "Use Tuya Smart and keep another working access method available.",
      "Keep the door open during installation and initial testing."
    ],
    "quick_specs": {
      "App": "Tuya Smart",
      "Door thickness": "35–55 mm",
      "Wi-Fi": "2.4 GHz only"
    },
    "search_placeholder": "Search installation, Wi-Fi, passwords or members"
  },
  "guides": [
    {
      "handle": "venix-01",
      "title": "What’s included",
      "category": "Installation",
      "steps": [
        "Open the product packaging carefully and remove all contents.",
        "Lay out all items on a clean, flat surface for easy identification.",
        "Check each item against the list below to confirm nothing is missing.",
        "If any item is missing or damaged, contact your local installer or dealer before proceeding."
      ],
      "notes": [
        "Keep the packaging materials until installation is complete in case you need to return any items.",
        "Use the 38 mm locator only for a 38 mm door hole; a 54 mm locator is fitted as standard."
      ],
      "warnings": [
        "Do not proceed with installation if any components are missing. Contact your local installer or dealer immediately to obtain replacement parts."
      ],
      "common_mistakes": [],
      "summary": "Verify that all components are present in the VENIX smart lock package before beginning installation.",
      "expected_result": "All eight components are present and undamaged: 2 keys, strike box, strike plate, deadbolt, 38mm locator, mounting plate, external panel unit, and internal panel unit.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-01-1.webp?v=1791322202",
          "alt": "What’s included — What's Included"
        }
      ]
    },
    {
      "handle": "venix-02",
      "title": "Product dimensions and overview",
      "category": "Installation",
      "steps": [
        "Review the dimension diagrams for the External Panel Unit to understand its size and mounting requirements.",
        "Review the dimension diagrams for the Internal Panel Unit to understand its size and battery compartment location.",
        "Identify all key components on both panels, including keypad area, sensor locations, and connection points.",
        "Measure your door thickness to confirm it falls within the compatible range of 35–55 mm."
      ],
      "notes": [
        "Refer to the product diagrams for exact millimeter measurements of both the external and internal panel units."
      ],
      "warnings": [
        "Incorrect understanding of panel dimensions may lead to improper door preparation or misalignment during installation."
      ],
      "common_mistakes": [],
      "summary": "Familiarize yourself with the VENIX smart lock dimensions and component layout before installation.",
      "expected_result": "You can identify all major components on both panels and confirm your door dimensions are compatible with the VENIX lock.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-02-1.webp?v=1791322203",
          "alt": "Product dimensions and overview — Product Dimension"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-02-2.webp?v=1791322203",
          "alt": "Product dimensions and overview — Product Overview"
        }
      ]
    },
    {
      "handle": "venix-03",
      "title": "Factory reset",
      "category": "Reset & ownership",
      "steps": [
        "Remove the battery cover on the rear of the internal panel unit to expose the Reset key.",
        "Press and hold the Reset key for 5 seconds until you hear 6 intermittent beeps.",
        "Wait for the voice prompt, then press the Unlock key on the front (external) panel to confirm the reset.",
        "Listen for the voice prompt \"Initialization Successful\" to confirm the factory reset is complete."
      ],
      "notes": [],
      "warnings": [
        "Factory reset erases all locally stored users and credentials. Use it only when you intend to reset and reconfigure the lock."
      ],
      "common_mistakes": [
        "Omitting the front Unlock-key confirmation after the voice prompt."
      ],
      "summary": "Factory reset is an optional recovery or ownership task. It erases locally stored users and credentials.",
      "expected_result": "The lock emits a confirmation voice prompt \"Initialization Successful\" and all user data is erased, returning the device to its original factory state.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-03-1.webp?v=1791322203",
          "alt": "Factory reset — System Initialization (Factory Reset)"
        }
      ]
    },
    {
      "handle": "venix-04",
      "title": "Set the unlocking direction",
      "category": "Installation",
      "steps": [
        "Confirm the lock is in factory default state with no users enrolled. If it is already configured, read the factory-reset warning before changing its handing.",
        "Insert the battery to power on the lock.",
        "Wait for the motor to automatically rotate and detect the unlocking direction.",
        "Listen for a long beep, which confirms the direction has been set successfully."
      ],
      "notes": [],
      "warnings": [
        "The unlocking direction can only be set when the lock is in factory default state with no users enrolled. If users are already registered, you must perform a factory reset first, which will erase all data. Plan this step before enrolling any members."
      ],
      "common_mistakes": [
        "Trying to set handing after users have been enrolled."
      ],
      "summary": "Configure the VENIX smart lock to detect and set the correct unlocking direction for your door orientation.",
      "expected_result": "The motor completes its rotation cycle and emits a long beep, indicating the unlocking direction is correctly configured for your door.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-04-1.webp?v=1791322203",
          "alt": "Set the unlocking direction — Setting the Unlocking Direction"
        }
      ]
    },
    {
      "handle": "venix-05",
      "title": "Install the bolt and strike plate",
      "category": "Installation",
      "steps": [
        "Verify your door thickness is between 35 mm and 55 mm using the template guide.",
        "Use the supplied template to mark the hole centerline at the required height; 970 mm from the floor is the source’s suggested height.",
        "Drill a 54mm diameter hole through the door for the lockset.",
        "Fold the template along the door edge and mark a 25mm diameter hole location for the bolt on the door edge.",
        "Drill the bolt hole and chisel a rectangular recess measuring 58mm x 26mm with a depth of 3mm.",
        "Adjust the bolt length according to your door's backset measurement.",
        "Align the bolt hole with the drive bar center and secure the bolt plate with screws.",
        "Extend the bolt fully, close the door gently against the door jamb, and mark the strike plate locations.",
        "Mark the center line on the door jamb, place the strike plate, and scribe the outline.",
        "Chisel the strike plate recess to a depth of 2mm and drill the bolt hole to a depth of 25mm.",
        "Insert the strike box and strike plate into the jamb recess and secure with screws."
      ],
      "notes": [
        "Use the supplied drilling template. The dimensions here are not a scale drawing; 970 mm is a suggested height, not a fixed installation requirement."
      ],
      "warnings": [
        "Drilling errors can permanently damage your door. Measure twice before drilling. Wear safety goggles and ensure the door is securely supported during drilling. If your door already has pre-drilled holes matching VENIX specifications, skip section 5.1 and proceed directly to bolt installation."
      ],
      "common_mistakes": [
        "Using the web illustration as a scale drilling template; use the supplied template."
      ],
      "summary": "Install the deadbolt and strike plate assembly into your door, including drilling new holes if your door is not pre-drilled.",
      "expected_result": "The deadbolt extends and retracts smoothly, aligning perfectly with the strike plate hole when the door is closed.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-05-1.webp?v=1791322203",
          "alt": "Install the bolt and strike plate — Drill Lockset and Bolt Holes"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-05-2.webp?v=1791322202",
          "alt": "Install the bolt and strike plate — Install Bolt"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-05-3.webp?v=1791322203",
          "alt": "Install the bolt and strike plate — Install Strike Plate"
        }
      ]
    },
    {
      "handle": "venix-06",
      "title": "Replace the locator",
      "category": "Installation",
      "steps": [
        "Loosen the two fixing screws on the external panel's locator.",
        "Remove the original 54mm locator carefully, keeping the screws for reuse.",
        "Route the connection cable underneath the new 38mm locator position.",
        "Fit the 38mm locator into place and tighten securely with the two screws."
      ],
      "notes": [
        "The external panel ships with a 54mm locator already installed. Only perform this replacement if your door hole diameter is 38mm. Always route the connection cable underneath the locator, never over it, to prevent cable damage."
      ],
      "warnings": [
        "Routing the cable over the locator instead of underneath can pinch or crush the cable when the locator is tightened, causing permanent connection failure."
      ],
      "common_mistakes": [
        "Routing the cable over the locator rather than underneath."
      ],
      "summary": "Replace the pre-fitted 54mm locator on the external panel with a 38mm locator if your door hole requires it.",
      "expected_result": "The 38mm locator is firmly attached to the external panel with the connection cable properly routed underneath it.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-06-1.webp?v=1791322203",
          "alt": "Replace the locator — Pre-assemble External Panel (Locator Replacement)"
        }
      ]
    },
    {
      "handle": "venix-07",
      "title": "Install the external panel",
      "category": "Installation",
      "steps": [
        "Pass the external handle connection cable through the door hole from the outside to the inside.",
        "Align the spindle of the external handle with the mortise mechanism inside the door.",
        "Place the external panel unit flush against the door surface.",
        "From inside the door, push the connector cable through the mounting plate opening.",
        "Fit the mounting plate onto the spindle, ensuring proper alignment.",
        "Select M4×30 mm screws for doors 35–45 mm thick, or M4×40 mm screws for doors over 45 mm up to 55 mm thick.",
        "Use two Screws D to temporarily fix the mounting plate in place."
      ],
      "notes": [
        "Select the correct screw length based on your door thickness: use M4x30mm screws for doors 35-45mm thick, and M4x40mm screws for doors thicker than 45mm up to 55mm. Install the tail bar vertically when the deadbolt is in the retracted position."
      ],
      "warnings": [
        "Using incorrect screw lengths can damage the door or fail to secure the panel properly. Ensure the connection cable is not pinched between the panel and door surface during installation."
      ],
      "common_mistakes": [
        "Fitting the tail bar horizontally while the bolt is retracted."
      ],
      "summary": "Mount the external panel unit to the door and connect it to the internal mounting plate.",
      "expected_result": "The external panel is aligned with the door, the connection cable passes through to the interior, and the mounting plate is temporarily secured with the correct screws.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-07-1.webp?v=1791322202",
          "alt": "Install the external panel — Install External Panel"
        }
      ]
    },
    {
      "handle": "venix-08",
      "title": "Install the internal panel and battery",
      "category": "Installation",
      "steps": [
        "Plug the external handle connector cable into the matching socket on the internal panel unit.",
        "Insert the tail bar into the inner panel knob mechanism.",
        "Attach the internal panel unit to the door, aligning it with the mounting plate and spindle.",
        "Tighten the internal panel screws using M5x10mm-B screws and M3x4mm-C screws securely.",
        "Open the battery compartment cover on the rear of the internal panel.",
        "Insert the lithium battery into the compartment, ensuring correct polarity alignment.",
        "Close the battery cover securely."
      ],
      "notes": [
        "Keep the door open after installation for commissioning and initial parameter settings. Do not close the door until you have verified all functions work correctly."
      ],
      "warnings": [
        "Ensure the lithium battery is inserted with correct polarity. Incorrect battery orientation can damage the lock's electronic components. Keep the door open during initial setup to avoid being locked out if configuration issues occur."
      ],
      "common_mistakes": [
        "Closing the door before commissioning and initial testing."
      ],
      "summary": "Install the internal panel unit, connect it to the external panel, and insert the battery to power the VENIX smart lock.",
      "expected_result": "Both panels are firmly mounted, the connection cable is properly plugged in, the battery is installed, and the lock powers on successfully.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-08-1.webp?v=1791322202",
          "alt": "Install the internal panel and battery — Install Internal Panel & Connect the Battery"
        }
      ]
    },
    {
      "handle": "venix-09",
      "title": "Set up the app",
      "category": "Using Venix",
      "steps": [
        "Open the App Store (iOS) or Google Play Store (Android) on your smartphone.",
        "Search for \"Tuya\" in the store.",
        "Download and install the official Tuya app.",
        "Open the Tuya app and sign up for a new account, or log in if you already have one.",
        "Follow the in-app prompts to add your VENIX smart lock to your device list."
      ],
      "notes": [
        "The Tuya app is required for all smart features including remote unlocking, user management, and network configuration. Ensure your smartphone has internet access during setup."
      ],
      "warnings": [],
      "common_mistakes": [],
      "summary": "Download and set up the Tuya app to control and manage your VENIX smart lock remotely.",
      "expected_result": "The Tuya app is installed on your smartphone, you have an active account, and the VENIX lock appears in your device list ready for network configuration.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-09-1.webp?v=1791322202",
          "alt": "Set up the app — Setup the App"
        }
      ]
    },
    {
      "handle": "venix-10",
      "title": "Connect to Wi-Fi",
      "category": "Using Venix",
      "steps": [
        "On the front (external) panel of the lock, press the \"3\" key and the \"🔓\" key simultaneously.",
        "Wait for the voice prompt and observe the indicator light blinking slowly, confirming pairing mode is active.",
        "Open the Tuya app on your smartphone and tap \"Add Device\".",
        "Select \"Venix\" from the device list.",
        "Select your 2.4 GHz Wi-Fi network from the available networks list.",
        "Enter your Wi-Fi password accurately and tap \"Next\".",
        "Wait for the app to complete the connection process with the door lock.",
        "When the app displays \"Device Added Successfully\", tap \"Done\" to finish setup."
      ],
      "notes": [],
      "warnings": [
        "The VENIX lock only supports 2.4 GHz Wi-Fi networks. It will not connect to 5 GHz networks. Ensure your router broadcasts a 2.4 GHz signal and that you have the correct password ready. If re-networking is needed after initial binding, you must unbind the device in the app, clear data, or restore factory defaults first."
      ],
      "common_mistakes": [
        "Choosing 5 GHz instead of 2.4 GHz Wi-Fi.",
        "Entering the wrong Wi-Fi password."
      ],
      "summary": "Connect your VENIX smart lock to your home Wi-Fi network through the Tuya app for remote access and control.",
      "expected_result": "The indicator light stops blinking, the app confirms \"Device Added Successfully\", and your VENIX lock appears as an online device in the Tuya app.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-10-1.webp?v=1791322202",
          "alt": "Connect to Wi-Fi — Network Setup (Add Lock over Wi-Fi)"
        }
      ]
    },
    {
      "handle": "venix-member-management",
      "title": "Member management",
      "category": "App management",
      "summary": "Member management in the Tuya app.",
      "steps": [
        "On the lock homepage, tap “Member Management”.",
        "Select a member to manage their password, face and palmprint credentials."
      ],
      "notes": [
        "To revoke access, delete the member’s credentials before removing the member."
      ],
      "warnings": [],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-member-management_2x_100dd69c-7bbc-431d-ac76-953905f14463.png?v=1791322273",
          "alt": "Member management — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 18,
      "common_mistakes": []
    },
    {
      "handle": "venix-11",
      "title": "Add or remove passwords",
      "category": "Using Venix",
      "steps": [
        "Open the Tuya app and navigate to your VENIX lock's homepage.",
        "Tap \"Member Management\" at the bottom of the screen.",
        "Select the designated member for whom you want to add or remove a password.",
        "To Add a Password: Tap \"+ Add\" beside the \"Password\" section.",
        "Enter a numeric password using the length requested by your app, then check the entry before saving.",
        "To Add a Password: Tap \"Save\" to confirm and store the password.",
        "To Remove a Password: Tap \"Delete Password\" in the member's credential list.",
        "To Remove a Password: Tap \"Confirm\" when prompted to permanently delete the password."
      ],
      "notes": [
        "Follow the password length shown by your app.",
        "The source describes Special Password as sending a hijack alert when used. Configure intended recipients in the app before relying on it."
      ],
      "warnings": [
        "Passwords are visible to anyone who observes entry. Choose passwords that are not easily guessable (avoid birthdays, sequential numbers like 123456, or repeated digits like 111111). Never share passwords via unsecured channels such as text messages or email."
      ],
      "common_mistakes": [],
      "summary": "Add or remove numeric passwords for individual members through the Tuya app's Member Management interface.",
      "expected_result": "The new password is saved and immediately active for unlocking, or the deleted password is removed and no longer grants access.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-11-1.webp?v=1791322203",
          "alt": "Add or remove passwords — Add a Password"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-11-2.webp?v=1791322203",
          "alt": "Add or remove passwords — Remove a Password"
        }
      ]
    },
    {
      "handle": "venix-12",
      "title": "Add or remove face recognition",
      "category": "Using Venix",
      "steps": [
        "Open the Tuya app and navigate to your VENIX lock's homepage.",
        "Tap \"Member Management\" at the bottom of the screen.",
        "Select the designated member for whom you want to add or remove face recognition.",
        "To Add Face Recognition: Tap \"+ Add\" beside the \"Face recognition\" section.",
        "To Add Face Recognition: Tap \"Start to add\" to begin the enrollment process.",
        "To Add Face Recognition: Position yourself 30–80 cm from the lock's face camera in normal indoor lighting.",
        "To Add Face Recognition: Face the camera directly and follow the on-screen prompts to complete face enrollment.",
        "To Add Face Recognition: Tap \"Done\" when enrollment is successfully completed.",
        "To Remove Face Recognition: Tap \"Delete Face recognition\" in the member's credential list.",
        "To Remove Face Recognition: Tap \"Confirm\" when prompted to permanently delete the face data."
      ],
      "notes": [
        "Face the camera directly and follow the on-screen prompts. The supplied PDF specifies 30–80 cm in normal indoor lighting."
      ],
      "warnings": [
        "Remove a person’s face credential when they should no longer have access."
      ],
      "common_mistakes": [
        "Ignoring the enrollment prompts or the recommended 30–80 cm distance."
      ],
      "summary": "Add or remove face recognition credentials for individual members through the Tuya app's Member Management interface.",
      "expected_result": "The face recognition credential is saved and the member can unlock the door by facing the camera, or the deleted face data is removed and no longer grants access.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-12-1.webp?v=1791322202",
          "alt": "Add or remove face recognition — Add Face Recognition"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-12-2.webp?v=1791322203",
          "alt": "Add or remove face recognition — Remove Face Recognition"
        }
      ]
    },
    {
      "handle": "venix-13",
      "title": "Add or remove palmprints",
      "category": "Using Venix",
      "steps": [
        "Enter the lock interface and tap \"Member Management\".",
        "Select the designated member from the member list.",
        "Tap \"+ Add\" beside the \"Palmprint\" option.",
        "Tap \"Start to add\" to begin the enrollment process.",
        "Place the same palm on the lock's palm-recognition area repeatedly until enrollment finishes, then tap \"Done\".",
        "To remove a palmprint, return to \"Member Management\", select the member, tap \"Delete palmprint\", and confirm deletion."
      ],
      "notes": [
        "Palm recognition requires placing the same palm repeatedly on the sensor area until enrollment completes successfully."
      ],
      "warnings": [
        "Ensure hands are clean and dry before enrolling palmprints. Moisture or dirt may reduce recognition accuracy."
      ],
      "common_mistakes": [
        "Changing palms during one enrollment."
      ],
      "summary": "Learn how to enroll and remove palmprint biometric data for authorized members on your VENIX smart lock.",
      "expected_result": "The palmprint is successfully enrolled or removed from the selected member's profile, and the lock recognizes or no longer accepts the registered palm.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-13-1.webp?v=1791322204",
          "alt": "Add or remove palmprints — Add Palmprint"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-13-2.webp?v=1791322202",
          "alt": "Add or remove palmprints — Remove Palmprint"
        }
      ]
    },
    {
      "handle": "venix-14",
      "title": "Manage temporary passcodes",
      "category": "Using Venix",
      "steps": [
        "Enter the lock interface and tap \"Temporary Passcode\".",
        "Choose the password type: Custom, Limited time, Single time, Dynamic, or Empty.",
        "Enter a password name (optional), set the effective start time and invalid end time, then tap \"Get password\".",
        "To remove a temporary passcode, enter the Temporary Passcode interface, tap \"Record\", select the password to remove, and tap Delete."
      ],
      "notes": [
        "Temporary passcodes include Custom, Limited time, Single time, Dynamic, and Empty password types to suit different access scenarios."
      ],
      "warnings": [
        "Time-limited passwords require obtaining a clear code from the app and entering it on the lock before deletion. One-time and dynamic passwords cannot be manually deleted—they expire automatically."
      ],
      "common_mistakes": [
        "Trying to delete one-time or dynamic codes manually; the source says they expire automatically."
      ],
      "summary": "Create and manage temporary passcodes with various validity options for guests or short-term access on your VENIX smart lock.",
      "expected_result": "A temporary passcode is generated with specified validity period, or an existing passcode is successfully removed from the system.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-14-1.webp?v=1791322203",
          "alt": "Manage temporary passcodes — Add a Temporary Passcode"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-14-2.webp?v=1791322202",
          "alt": "Manage temporary passcodes — Remove a Temporary Passcode"
        }
      ]
    },
    {
      "handle": "venix-15",
      "title": "Doorbell and remote unlocking",
      "category": "Using Venix",
      "steps": [
        "Pair the lock with Wi-Fi through the lock interface settings.",
        "Press the doorbell key on the external panel—the paired phone receives a doorbell request notification.",
        "Tap the notification to view the scene outside the door, accept the call to talk with visitors, or tap Unlock to open the door remotely.",
        "For direct remote unlock, open the lock homepage and press and hold the unlock icon until the app confirms.",
        "Alternatively, tap \"Video surveillance\" on the lock homepage to view real-time outdoor footage and unlock remotely from the video interface."
      ],
      "notes": [
        "The lock must be paired with Wi-Fi before doorbell unlocking or remote unlock features can function properly."
      ],
      "warnings": [
        "Ensure stable Wi-Fi connection to avoid failed remote unlock attempts. Test the feature after initial setup to confirm functionality."
      ],
      "common_mistakes": [],
      "summary": "Enable doorbell-triggered remote unlocking and direct remote unlock functionality through the VENIX app with Wi-Fi connectivity.",
      "expected_result": "A doorbell press sends a notification to the paired phone, and an authorised remote-unlock command operates the lock when it is connected.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-15-1.webp?v=1791322203",
          "alt": "Doorbell and remote unlocking — Doorbell Unlocking"
        },
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-15-2.webp?v=1791322273",
          "alt": "Doorbell and remote unlocking — Remote Unlock"
        }
      ]
    },
    {
      "handle": "venix-16",
      "title": "Permissions and Dormant switch",
      "category": "Using Venix",
      "steps": [
        "Tap \"Set\" on the lock homepage to access settings.",
        "Tap \"Permission Settings\" and choose one of three options: Only administrators, Can be used by all users, or Not available to all users.",
        "Tap \"Confirm\" to apply the selected permission level.",
        "To enable the Dormant switch, navigate to settings and activate the Dormant switch option."
      ],
      "notes": [
        "The Dormant switch limits functions during its sleep period, including live video and remote management.",
        "Permission Settings controls remote unlock. “Not available to all users” disables remote unlock; it does not disable every local access method."
      ],
      "warnings": [],
      "common_mistakes": [
        "Assuming the remote-unlock permission disables all local unlocking methods."
      ],
      "summary": "Configure user permission levels and activate the Dormant switch to restrict lock functionality during designated sleep periods.",
      "expected_result": "Permission restrictions apply to specified user groups, and the sleep switch disables the use of video monitoring and remote management functions during the configured sleep period.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-16-1.webp?v=1791322273",
          "alt": "Permissions and Dormant switch — Permission Settings & Dormant Switch"
        }
      ]
    },
    {
      "handle": "venix-17",
      "title": "Automatic lock and lock delay",
      "category": "Using Venix",
      "steps": [
        "Enter the lock interface and tap \"Set\" to access settings.",
        "Turn on the \"Automatic lock switch\" to enable auto-lock functionality.",
        "Tap “Auto lock delay time set”, choose the delay shown in the app, then confirm.",
        "Tap \"Confirm\" to save the selected delay time.",
        "Test with the door open first: unlock and check that the bolt re-engages after the selected delay. Then check door and strike alignment before testing normal closed-door operation."
      ],
      "notes": [
        "The PDF states that the timer runs after each unlock. This is not confirmation that the door has closed."
      ],
      "warnings": [
        "Ensure the door closes completely before the auto-lock delay expires. Obstructions or improperly closed doors may prevent successful automatic locking."
      ],
      "common_mistakes": [
        "Treating the timer as confirmation that the door is closed."
      ],
      "summary": "Set the automatic re-bolting delay after each unlock.",
      "expected_result": "The bolt re-engages after the configured delay following each unlock. A secure door still requires the bolt to enter the aligned strike plate.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-17-1.webp?v=1791322273",
          "alt": "Automatic lock and lock delay — Automatic Lock & Lock Delay"
        }
      ]
    },
    {
      "handle": "venix-volume",
      "title": "Lock navigation volume",
      "category": "App management",
      "summary": "Lock navigation volume in the Tuya app.",
      "steps": [
        "On the lock homepage, tap “Set”.",
        "Tap “Lock navigation volume” and choose Mute, Low, Normal or High.",
        "Tap “Confirm”."
      ],
      "notes": [],
      "warnings": [],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-volume_2x_d8b8b9c5-7dc5-40a3-99e0-c913da635e61.png?v=1791322273",
          "alt": "Lock navigation volume — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 35,
      "common_mistakes": []
    },
    {
      "handle": "venix-records",
      "title": "Alerts and records",
      "category": "App management",
      "summary": "Alerts and records in the Tuya app.",
      "steps": [
        "Open “Album / Log”, then “Log”.",
        "Choose “Alarm messages” to review event notifications.",
        "Choose “Door opening record” to review recorded unlock events and timestamps."
      ],
      "notes": [
        "The PDF also describes an optional “Cloud storage service” in Set for doorbell videos and alarm snapshots. Review its terms in the app before enabling it."
      ],
      "warnings": [],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-records_2x_7579fd23-1a3e-46c8-8c7a-958e085dcc43.png?v=1791322273",
          "alt": "Alerts and records — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 36,
      "common_mistakes": []
    },
    {
      "handle": "venix-18",
      "title": "Unbind or remove the device",
      "category": "Reset & ownership",
      "steps": [
        "Enter the lock interface and tap the pencil icon in the top-right corner to access device management.",
        "Tap \"Remove Device\" to initiate the unbinding process.",
        "Select \"Unbind and wipe data\" to perform a complete factory reset, or choose \"Unbind\" to only disconnect from the app while preserving data.",
        "Tap \"Confirm\" to execute the selected unbind option."
      ],
      "notes": [
        "Two unbind options exist—\"Unbind\" only disconnects the lock from the app while preserving all user data, whereas \"Unbind and wipe data\" performs a complete factory reset erasing all biometric data, passcodes, and member profiles."
      ],
      "warnings": [
        "Unbind and wipe data erases the lock’s registered user data. Choose it only when you intend to reset the lock; Unbind alone preserves local user data."
      ],
      "common_mistakes": [
        "Choosing Unbind alone when you intend to wipe registered user data."
      ],
      "summary": "Completely unbind and factory-reset your VENIX smart lock to remove all user data and disconnect it from the Tuya app for transfer or reconfiguration.",
      "expected_result": "The lock is fully disconnected from the Tuya app, and if \"Unbind and wipe data\" was selected, all user data is erased and the lock returns to factory-default state ready for new ownership or reconfiguration.",
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-18-1.webp?v=1791322273",
          "alt": "Unbind or remove the device — Unbind   Remove Device"
        }
      ]
    },
    {
      "handle": "venix-create-home",
      "title": "Create a home",
      "category": "App management",
      "summary": "Create a home in the Tuya app.",
      "steps": [
        "On the app homepage, tap “Me”, then “Home Management”.",
        "Tap “Create a Home”.",
        "Enter the home name, optionally set the location, select or add rooms, then tap “Save”."
      ],
      "notes": [
        "The person creating the home becomes its Homeowner."
      ],
      "warnings": [],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-create-home_2x_2ad74c97-8f23-40a7-970f-f28857001fcc.png?v=1791322273",
          "alt": "Create a home — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 39,
      "common_mistakes": []
    },
    {
      "handle": "venix-add-member",
      "title": "Add an administrator or common member",
      "category": "App management",
      "summary": "Add an administrator or common member in the Tuya app.",
      "steps": [
        "Open “Home Management” and select the home.",
        "Tap “Add Member”.",
        "Under “Family Role”, choose Administrator or Common Member.",
        "Enter the required name, region and account details, then tap “Save”."
      ],
      "notes": [
        "The member must register a Tuya account before being added."
      ],
      "warnings": [],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-add-member_2x_7d121ca7-8be6-47c8-a121-c208992f1f9e.png?v=1791322273",
          "alt": "Add an administrator or common member — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 40,
      "common_mistakes": []
    },
    {
      "handle": "venix-transfer-home",
      "title": "Transfer homeownership",
      "category": "App management",
      "summary": "Transfer homeownership in the Tuya app.",
      "steps": [
        "Open “Home Management” and select the home.",
        "Tap “Manage Permissions”, then “Transfer Home Ownership”.",
        "Select the new Homeowner and tap “Confirm”."
      ],
      "notes": [],
      "warnings": [
        "Make sure the new owner already has administrator rights on the lock. You will no longer be Homeowner after transfer."
      ],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-transfer-home_2x_81290b07-4616-41f6-85a1-0a1c669b69e9.png?v=1791322273",
          "alt": "Transfer homeownership — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 42,
      "common_mistakes": []
    },
    {
      "handle": "venix-remove-member",
      "title": "Remove a member",
      "category": "App management",
      "summary": "Remove a member in the Tuya app.",
      "steps": [
        "Delete the member’s password, face and palmprint credentials if their access should be revoked.",
        "Open “Home Management” and select the home.",
        "Select the member, tap “Remove Member” and confirm."
      ],
      "notes": [],
      "warnings": [
        "Removing a member does not delete their unlocking credentials. Delete those separately before removing the member."
      ],
      "images": [
        {
          "src": "https://cdn.shopify.com/s/files/1/0693/8309/4429/files/us-manual-venix-remove-member_2x_a014cd1b-f3b7-4502-9142-58baf1f44833.png?v=1791322273",
          "alt": "Remove a member — original supplier instructions and app illustrations."
        }
      ],
      "source_pdf_page": 44,
      "common_mistakes": []
    }
  ],
  "troubleshooting": [
    {
      "handle": "venix-wifi-help",
      "title": "Venix won’t connect to Wi-Fi",
      "category": "App setup",
      "quick_checks": [
        "Use Tuya Smart and a 2.4 GHz Wi-Fi network.",
        "Check the Wi-Fi password.",
        "Press 3 and the unlock key on the front panel as shown in Network setup."
      ],
      "fix_steps": [
        "Follow the network guide and wait for Device Added Successfully.",
        "If already bound, read the source’s re-networking note and the data-removal warning before changing the binding.",
        "If uncertain, send support the app message and stage where adding stops."
      ],
      "related_guides": [
        "venix-09",
        "venix-10",
        "venix-18"
      ]
    },
    {
      "handle": "venix-face-help",
      "title": "Face enrollment needs another attempt",
      "category": "Credentials",
      "quick_checks": [
        "Face the camera directly.",
        "The supplier PDF recommends 30–80 cm in normal indoor lighting."
      ],
      "fix_steps": [
        "Open the intended member’s Face recognition entry and follow the enrollment prompts."
      ],
      "related_guides": [
        "venix-12"
      ]
    },
    {
      "handle": "venix-revoke-help",
      "title": "Remove someone’s access",
      "category": "Members",
      "explanation": "Removing a home member does not delete their unlocking credentials.",
      "quick_checks": [
        "Check the member name and their registered credentials."
      ],
      "fix_steps": [
        "Delete their passwords, face and palmprint credentials as required.",
        "Then remove the member from the home."
      ],
      "related_guides": [
        "venix-11",
        "venix-12",
        "venix-13",
        "venix-remove-member"
      ]
    },
    {
      "handle": "venix-autolock-help",
      "title": "Understand automatic locking",
      "category": "Lock settings",
      "explanation": "The source says the timer starts after an unlock; it does not establish that the door is closed.",
      "quick_checks": [
        "Check Automatic lock switch and the selected delay in Set."
      ],
      "fix_steps": [
        "Test with the door open first, then check door and strike alignment before normal use."
      ],
      "related_guides": [
        "venix-17",
        "venix-05"
      ]
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Installation or handing help",
      "subject": "Venix — installation support",
      "body": "Hi Blusafe team,\n\nOrder number: \nDoor thickness: \nHole diameter and backset: \nInstallation step: \nWhat does not align or move correctly?: \n\nI have attached photos of both panels, the door edge and the affected parts.\n\nThanks,\n[Your name]"
    },
    {
      "title": "App, network or credential help",
      "subject": "Venix — app support",
      "body": "Hi Blusafe team,\n\nOrder number: \nPhone model: \nTuya Smart version: \nSelected Wi-Fi band: \nGuide and step: \nError message: \n\nI have attached the relevant screenshot with passwords and personal credentials hidden.\n\nThanks,\n[Your name]"
    }
  ],
  "support_email": "enquiries@blusafesolutions.com",
  "search_index": [
    {
      "title": "What’s included",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-01",
      "summary": "Verify that all components are present in the VENIX smart lock package before beginning installation.",
      "keywords": "Open the product packaging carefully and remove all contents. Lay out all items on a clean, flat surface for easy identification. Check each item against the list below to confirm nothing is missing. If any item is missing or damaged, contact your local installer or dealer before proceeding. Keep the packaging materials until installation is complete in case you need to return any items. Use the 38 mm locator only for a 38 mm door hole; a 54 mm locator is fitted as standard."
    },
    {
      "title": "Product dimensions and overview",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-02",
      "summary": "Familiarize yourself with the VENIX smart lock dimensions and component layout before installation.",
      "keywords": "Review the dimension diagrams for the External Panel Unit to understand its size and mounting requirements. Review the dimension diagrams for the Internal Panel Unit to understand its size and battery compartment location. Identify all key components on both panels, including keypad area, sensor locations, and connection points. Measure your door thickness to confirm it falls within the compatible range of 35–55 mm. Refer to the product diagrams for exact millimeter measurements of both the external and internal panel units."
    },
    {
      "title": "Factory reset",
      "type": "guide",
      "category": "Reset & ownership",
      "anchor": "venix-03",
      "summary": "Factory reset is an optional recovery or ownership task. It erases locally stored users and credentials.",
      "keywords": "Remove the battery cover on the rear of the internal panel unit to expose the Reset key. Press and hold the Reset key for 5 seconds until you hear 6 intermittent beeps. Wait for the voice prompt, then press the Unlock key on the front (external) panel to confirm the reset. Listen for the voice prompt \"Initialization Successful\" to confirm the factory reset is complete."
    },
    {
      "title": "Set the unlocking direction",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-04",
      "summary": "Configure the VENIX smart lock to detect and set the correct unlocking direction for your door orientation.",
      "keywords": "Confirm the lock is in factory default state with no users enrolled. If it is already configured, read the factory-reset warning before changing its handing. Insert the battery to power on the lock. Wait for the motor to automatically rotate and detect the unlocking direction. Listen for a long beep, which confirms the direction has been set successfully."
    },
    {
      "title": "Install the bolt and strike plate",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-05",
      "summary": "Install the deadbolt and strike plate assembly into your door, including drilling new holes if your door is not pre-drilled.",
      "keywords": "Verify your door thickness is between 35 mm and 55 mm using the template guide. Use the supplied template to mark the hole centerline at the required height; 970 mm from the floor is the source’s suggested height. Drill a 54mm diameter hole through the door for the lockset. Fold the template along the door edge and mark a 25mm diameter hole location for the bolt on the door edge. Drill the bolt hole and chisel a rectangular recess measuring 58mm x 26mm with a depth of 3mm. Adjust the bolt length according to your door's backset measurement. Align the bolt hole with the drive bar center and secure the bolt plate with screws. Extend the bolt fully, close the door gently against the door jamb, and mark the strike plate locations. Mark the center line on the door jamb, place the strike plate, and scribe the outline. Chisel the strike plate recess to a depth of 2mm and drill the bolt hole to a depth of 25mm. Insert the strike box and strike plate into the jamb recess and secure with screws. Use the supplied drilling template. The dimensions here are not a scale drawing; 970 mm is a suggested height, not a fixed installation requirement."
    },
    {
      "title": "Replace the locator",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-06",
      "summary": "Replace the pre-fitted 54mm locator on the external panel with a 38mm locator if your door hole requires it.",
      "keywords": "Loosen the two fixing screws on the external panel's locator. Remove the original 54mm locator carefully, keeping the screws for reuse. Route the connection cable underneath the new 38mm locator position. Fit the 38mm locator into place and tighten securely with the two screws. The external panel ships with a 54mm locator already installed. Only perform this replacement if your door hole diameter is 38mm. Always route the connection cable underneath the locator, never over it, to prevent cable damage."
    },
    {
      "title": "Install the external panel",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-07",
      "summary": "Mount the external panel unit to the door and connect it to the internal mounting plate.",
      "keywords": "Pass the external handle connection cable through the door hole from the outside to the inside. Align the spindle of the external handle with the mortise mechanism inside the door. Place the external panel unit flush against the door surface. From inside the door, push the connector cable through the mounting plate opening. Fit the mounting plate onto the spindle, ensuring proper alignment. Select M4×30 mm screws for doors 35–45 mm thick, or M4×40 mm screws for doors over 45 mm up to 55 mm thick. Use two Screws D to temporarily fix the mounting plate in place. Select the correct screw length based on your door thickness: use M4x30mm screws for doors 35-45mm thick, and M4x40mm screws for doors thicker than 45mm up to 55mm. Install the tail bar vertically when the deadbolt is in the retracted position."
    },
    {
      "title": "Install the internal panel and battery",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-08",
      "summary": "Install the internal panel unit, connect it to the external panel, and insert the battery to power the VENIX smart lock.",
      "keywords": "Plug the external handle connector cable into the matching socket on the internal panel unit. Insert the tail bar into the inner panel knob mechanism. Attach the internal panel unit to the door, aligning it with the mounting plate and spindle. Tighten the internal panel screws using M5x10mm-B screws and M3x4mm-C screws securely. Open the battery compartment cover on the rear of the internal panel. Insert the lithium battery into the compartment, ensuring correct polarity alignment. Close the battery cover securely. Keep the door open after installation for commissioning and initial parameter settings. Do not close the door until you have verified all functions work correctly."
    },
    {
      "title": "Set up the app",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-09",
      "summary": "Download and set up the Tuya app to control and manage your VENIX smart lock remotely.",
      "keywords": "Open the App Store (iOS) or Google Play Store (Android) on your smartphone. Search for \"Tuya\" in the store. Download and install the official Tuya app. Open the Tuya app and sign up for a new account, or log in if you already have one. Follow the in-app prompts to add your VENIX smart lock to your device list. The Tuya app is required for all smart features including remote unlocking, user management, and network configuration. Ensure your smartphone has internet access during setup."
    },
    {
      "title": "Connect to Wi-Fi",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-10",
      "summary": "Connect your VENIX smart lock to your home Wi-Fi network through the Tuya app for remote access and control.",
      "keywords": "On the front (external) panel of the lock, press the \"3\" key and the \"🔓\" key simultaneously. Wait for the voice prompt and observe the indicator light blinking slowly, confirming pairing mode is active. Open the Tuya app on your smartphone and tap \"Add Device\". Select \"Venix\" from the device list. Select your 2.4 GHz Wi-Fi network from the available networks list. Enter your Wi-Fi password accurately and tap \"Next\". Wait for the app to complete the connection process with the door lock. When the app displays \"Device Added Successfully\", tap \"Done\" to finish setup."
    },
    {
      "title": "Member management",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-member-management",
      "summary": "Member management in the Tuya app.",
      "keywords": "On the lock homepage, tap “Member Management”. Select a member to manage their password, face and palmprint credentials. To revoke access, delete the member’s credentials before removing the member."
    },
    {
      "title": "Add or remove passwords",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-11",
      "summary": "Add or remove numeric passwords for individual members through the Tuya app's Member Management interface.",
      "keywords": "Open the Tuya app and navigate to your VENIX lock's homepage. Tap \"Member Management\" at the bottom of the screen. Select the designated member for whom you want to add or remove a password. To Add a Password: Tap \"+ Add\" beside the \"Password\" section. Enter a numeric password using the length requested by your app, then check the entry before saving. To Add a Password: Tap \"Save\" to confirm and store the password. To Remove a Password: Tap \"Delete Password\" in the member's credential list. To Remove a Password: Tap \"Confirm\" when prompted to permanently delete the password. Follow the password length shown by your app. The source describes Special Password as sending a hijack alert when used. Configure intended recipients in the app before relying on it."
    },
    {
      "title": "Add or remove face recognition",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-12",
      "summary": "Add or remove face recognition credentials for individual members through the Tuya app's Member Management interface.",
      "keywords": "Open the Tuya app and navigate to your VENIX lock's homepage. Tap \"Member Management\" at the bottom of the screen. Select the designated member for whom you want to add or remove face recognition. To Add Face Recognition: Tap \"+ Add\" beside the \"Face recognition\" section. To Add Face Recognition: Tap \"Start to add\" to begin the enrollment process. To Add Face Recognition: Position yourself 30–80 cm from the lock's face camera in normal indoor lighting. To Add Face Recognition: Face the camera directly and follow the on-screen prompts to complete face enrollment. To Add Face Recognition: Tap \"Done\" when enrollment is successfully completed. To Remove Face Recognition: Tap \"Delete Face recognition\" in the member's credential list. To Remove Face Recognition: Tap \"Confirm\" when prompted to permanently delete the face data. Face the camera directly and follow the on-screen prompts. The supplied PDF specifies 30–80 cm in normal indoor lighting."
    },
    {
      "title": "Add or remove palmprints",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-13",
      "summary": "Learn how to enroll and remove palmprint biometric data for authorized members on your VENIX smart lock.",
      "keywords": "Enter the lock interface and tap \"Member Management\". Select the designated member from the member list. Tap \"+ Add\" beside the \"Palmprint\" option. Tap \"Start to add\" to begin the enrollment process. Place the same palm on the lock's palm-recognition area repeatedly until enrollment finishes, then tap \"Done\". To remove a palmprint, return to \"Member Management\", select the member, tap \"Delete palmprint\", and confirm deletion. Palm recognition requires placing the same palm repeatedly on the sensor area until enrollment completes successfully."
    },
    {
      "title": "Manage temporary passcodes",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-14",
      "summary": "Create and manage temporary passcodes with various validity options for guests or short-term access on your VENIX smart lock.",
      "keywords": "Enter the lock interface and tap \"Temporary Passcode\". Choose the password type: Custom, Limited time, Single time, Dynamic, or Empty. Enter a password name (optional), set the effective start time and invalid end time, then tap \"Get password\". To remove a temporary passcode, enter the Temporary Passcode interface, tap \"Record\", select the password to remove, and tap Delete. Temporary passcodes include Custom, Limited time, Single time, Dynamic, and Empty password types to suit different access scenarios."
    },
    {
      "title": "Doorbell and remote unlocking",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-15",
      "summary": "Enable doorbell-triggered remote unlocking and direct remote unlock functionality through the VENIX app with Wi-Fi connectivity.",
      "keywords": "Pair the lock with Wi-Fi through the lock interface settings. Press the doorbell key on the external panel—the paired phone receives a doorbell request notification. Tap the notification to view the scene outside the door, accept the call to talk with visitors, or tap Unlock to open the door remotely. For direct remote unlock, open the lock homepage and press and hold the unlock icon until the app confirms. Alternatively, tap \"Video surveillance\" on the lock homepage to view real-time outdoor footage and unlock remotely from the video interface. The lock must be paired with Wi-Fi before doorbell unlocking or remote unlock features can function properly."
    },
    {
      "title": "Permissions and Dormant switch",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-16",
      "summary": "Configure user permission levels and activate the Dormant switch to restrict lock functionality during designated sleep periods.",
      "keywords": "Tap \"Set\" on the lock homepage to access settings. Tap \"Permission Settings\" and choose one of three options: Only administrators, Can be used by all users, or Not available to all users. Tap \"Confirm\" to apply the selected permission level. To enable the Dormant switch, navigate to settings and activate the Dormant switch option. The Dormant switch limits functions during its sleep period, including live video and remote management. Permission Settings controls remote unlock. “Not available to all users” disables remote unlock; it does not disable every local access method."
    },
    {
      "title": "Automatic lock and lock delay",
      "type": "guide",
      "category": "Using Venix",
      "anchor": "venix-17",
      "summary": "Set the automatic re-bolting delay after each unlock.",
      "keywords": "Enter the lock interface and tap \"Set\" to access settings. Turn on the \"Automatic lock switch\" to enable auto-lock functionality. Tap “Auto lock delay time set”, choose the delay shown in the app, then confirm. Tap \"Confirm\" to save the selected delay time. Test with the door open first: unlock and check that the bolt re-engages after the selected delay. Then check door and strike alignment before testing normal closed-door operation. The PDF states that the timer runs after each unlock. This is not confirmation that the door has closed."
    },
    {
      "title": "Lock navigation volume",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-volume",
      "summary": "Lock navigation volume in the Tuya app.",
      "keywords": "On the lock homepage, tap “Set”. Tap “Lock navigation volume” and choose Mute, Low, Normal or High. Tap “Confirm”."
    },
    {
      "title": "Alerts and records",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-records",
      "summary": "Alerts and records in the Tuya app.",
      "keywords": "Open “Album / Log”, then “Log”. Choose “Alarm messages” to review event notifications. Choose “Door opening record” to review recorded unlock events and timestamps. The PDF also describes an optional “Cloud storage service” in Set for doorbell videos and alarm snapshots. Review its terms in the app before enabling it."
    },
    {
      "title": "Unbind or remove the device",
      "type": "guide",
      "category": "Reset & ownership",
      "anchor": "venix-18",
      "summary": "Completely unbind and factory-reset your VENIX smart lock to remove all user data and disconnect it from the Tuya app for transfer or reconfiguration.",
      "keywords": "Enter the lock interface and tap the pencil icon in the top-right corner to access device management. Tap \"Remove Device\" to initiate the unbinding process. Select \"Unbind and wipe data\" to perform a complete factory reset, or choose \"Unbind\" to only disconnect from the app while preserving data. Tap \"Confirm\" to execute the selected unbind option. Two unbind options exist—\"Unbind\" only disconnects the lock from the app while preserving all user data, whereas \"Unbind and wipe data\" performs a complete factory reset erasing all biometric data, passcodes, and member profiles."
    },
    {
      "title": "Create a home",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-create-home",
      "summary": "Create a home in the Tuya app.",
      "keywords": "On the app homepage, tap “Me”, then “Home Management”. Tap “Create a Home”. Enter the home name, optionally set the location, select or add rooms, then tap “Save”. The person creating the home becomes its Homeowner."
    },
    {
      "title": "Add an administrator or common member",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-add-member",
      "summary": "Add an administrator or common member in the Tuya app.",
      "keywords": "Open “Home Management” and select the home. Tap “Add Member”. Under “Family Role”, choose Administrator or Common Member. Enter the required name, region and account details, then tap “Save”. The member must register a Tuya account before being added."
    },
    {
      "title": "Transfer homeownership",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-transfer-home",
      "summary": "Transfer homeownership in the Tuya app.",
      "keywords": "Open “Home Management” and select the home. Tap “Manage Permissions”, then “Transfer Home Ownership”. Select the new Homeowner and tap “Confirm”."
    },
    {
      "title": "Remove a member",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-remove-member",
      "summary": "Remove a member in the Tuya app.",
      "keywords": "Delete the member’s password, face and palmprint credentials if their access should be revoked. Open “Home Management” and select the home. Select the member, tap “Remove Member” and confirm."
    },
    {
      "title": "Venix won’t connect to Wi-Fi",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "venix-wifi-help",
      "summary": "Venix won’t connect to Wi-Fi",
      "keywords": "Use Tuya Smart and a 2.4 GHz Wi-Fi network. Check the Wi-Fi password. Press 3 and the unlock key on the front panel as shown in Network setup. Follow the network guide and wait for Device Added Successfully. If already bound, read the source’s re-networking note and the data-removal warning before changing the binding. If uncertain, send support the app message and stage where adding stops."
    },
    {
      "title": "Face enrollment needs another attempt",
      "type": "troubleshooting",
      "category": "Credentials",
      "anchor": "venix-face-help",
      "summary": "Face enrollment needs another attempt",
      "keywords": "Face the camera directly. The supplier PDF recommends 30–80 cm in normal indoor lighting. Open the intended member’s Face recognition entry and follow the enrollment prompts."
    },
    {
      "title": "Remove someone’s access",
      "type": "troubleshooting",
      "category": "Members",
      "anchor": "venix-revoke-help",
      "summary": "Removing a home member does not delete their unlocking credentials.",
      "keywords": "Check the member name and their registered credentials. Delete their passwords, face and palmprint credentials as required. Then remove the member from the home."
    },
    {
      "title": "Understand automatic locking",
      "type": "troubleshooting",
      "category": "Lock settings",
      "anchor": "venix-autolock-help",
      "summary": "The source says the timer starts after an unlock; it does not establish that the door is closed.",
      "keywords": "Check Automatic lock switch and the selected delay in Set. Test with the door open first, then check door and strike alignment before normal use."
    }
  ]
};
